import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export type CategoryAttributeInput = {
  name: string;
  description: string;
  dataType: string;
  required: boolean;
  validationExpr?: string | null;
  options?: string[] | null;
};

export const categoryCreateAtom = createMutationAtomFactory(
  'settings.categoryCreate',
  (params: {
    name: string;
    description: string;
    attributes: CategoryAttributeInput[];
  }) => ({
    inventoryCategoryCreate: {
      __args: {
        input: {
          name: params.name,
          description: params.description,
          attributes: params.attributes,
        },
      },
      id: true,
      name: true,
      timestamps: {
        createdAt: true,
      },
    },
  }),
);
